module.exports = __webpack_public_path__ + "static/media/smoking-ban.33828e91.svg";